/**
 * Single source of truth for the TABA brand mark.
 * Renders the navy + copper companylogocropped.png (marble bust + decorative oval
 * + TABA wordmark + "THE ART BY ARTIST" tagline) wherever the logo
 * is needed — navbar, footer, hero, etc.
 *
 * The SVG is served from /public so we reference it as a stable URL
 * string. This avoids relying on webpack SVG imports.
 *
 *   • "sm"  — small navbar lockup (~40×40)
 *   • "md"  — comfortable footer lockup (~56×56)
 *   • "lg"  — section intro (~200×200)
 *   • "xl"  — large display (~320×320)
 *   • "hero" — full-bleed statue on the home page (~58svh)
 */




export default function Logo({
  size = "md",
  className = "",
  loading = "eager",
}) {
  const sizeMap = {
    sm: "h-10 w-auto",
    md: "h-14 w-auto",
    lg: "h-44 w-auto sm:h-52",
    xl: "h-[23rem] w-auto sm:h-[22.5rem]",
    hero: "h-[58svh] w-auto max-h-[36rem]",
  };

  return (
    <img
      src="/companylogocropped.png"
      alt="TABA — The Art By Artist"
      loading={loading}
      className={`select-none object-contain ${sizeMap[size]} ${className}`}
      draggable="false"
    />
  );
}